export default "__VITE_ASSET__i5KCVg85__"